<template>
  <div id="app">
    <router-view style="overscroll-behavior-y: contain" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
:root {
  --qs-primary-color: #409eff;
  --qs-primary-light-color: #f2f6fc;
  --qs-primary-lighter-color: #ecf5ff;

  --qs-success-color: #67c23a;
  --qs-success-light-color: #e1f3d8;
  --qs-success-lighter-color: #f0f9eb;

  --qs-warning-color: #e6a23c;
  --qs-warning-light-color: #faecd8;
  --qs-warning-lighter-color: #fdf6ec;

  --qs-danger-color: #f56c6c;
  --qs-danger-light-color: #fde2e2;
  --qs-danger-lighter-color: #fef0f0;

  --qs-error-color: #f56c6c;
  --qs-error-light-color: #fde2e2;
  --qs-error-lighter-color: #fef0f0;

  --qs-info-color: #909399;
  --qs-info-light-color: #e9e9eb;
  --qs-info-lighter-color: #f4f4f5;

  --qs-primary-text-color: #303133;
  --qs-regular-text-color: #606266;
  --qs-secondary-text-color: #909399;
  --qs-placeholder-color: #c0c4cc;

  --qs-border-color: #dcdfe6;
  --qs-border-light-color: #e4e7ed;
  --qs-border-lighter-color: #ebeef5;
  --qs-border-extralight-color: #f2f6fc;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  min-width: 1280px;
  min-height: 600px;
}
* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/*全局滚动条样式*/
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  cursor: pointer;
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
.el-table__body-wrapper::-webkit-scrollbar {
  cursor: pointer;
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

/*
主要是靠这个 注意 
上面.el-table__body-wrapper::-webkit-scrollbar 是 30px 下面这个也要 30px
*/
.el-scrollbar__wrap::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*全局滚动条样式结束*/

.el-table__fixed {
  height: 100% !important;
}
.el-table__fixed-right {
  height: 100% !important;
}

.el-divider--horizontal {
  margin: 10px 0;
}

.el-button [class*="el-icon-"] + span {
  margin-left: 0px !important;
}

/* 分页靠右 */
.el-pagination {
  text-align: right;
  padding-top: 10px;
}

.el-dialog__body > .el-tabs {
  margin-top: -30px;
}

.el-dropdown-menu__item .el-button {
  width: 100%;
  text-align: left;
}

img {
  image-rendering: -webkit-optimize-contrast;
}

/* qsclass */
.qs {
  &-pointer {
    cursor: pointer;
  }

  &-link {
    cursor: pointer;
  }

  &-link:hover {
    text-decoration: underline;
  }

  &-unread:before {
    content: "● ";
    color: var(--qs-primary-color);
  }

  &-nowarp {
    text-wrap: nowrap;
  }

  @each $type in ("padding", "margin") {
    &-#{$type} {
      @each $direction in ("right", "left", "top", "bottom") {
        &-#{$direction} {
          @for $i from 0 through 200 {
            $size: $i * 5;

            &-#{$size} {
              #{$type}-#{$direction}: $size + px !important;
            }
          }
        }
      }

      @for $i from 0 through 200 {
        $size: $i * 5;

        &-#{$size} {
          #{$type}: $size + px !important;
        }
      }
    }
  }

  @each $abbr, $type in (m: "margin", p: "padding") {
    @each $dirAbbr, $direction in (t: "top", r: "right", b: "bottom", l: "left")
    {
      @for $i from 0 through 200 {
        $size: $i * 5;

        &-#{$abbr}#{$dirAbbr}-#{$size} {
          #{$type}-#{$direction}: $size + px !important;
        }
      }
    }

    @for $i from 0 through 200 {
      $size: $i * 5;

      &-#{$abbr}-#{$size} {
        #{$type}: $size + px !important;
      }
    }
  }

  &-relative,
  &-rela {
    position: relative !important;
  }

  &-absolute,
  &-abso {
    position: absolute !important;
  }

  &-flex {
    display: flex !important;
    flex-direction: row !important;
    justify-content: flex-start !important;
    align-items: center !important;
  }

  &-childflex {
    > * {
      display: flex !important;
      flex-direction: row !important;
      justify-content: flex-start !important;
      align-items: center !important;
    }
  }

  &-center {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
    justify-content: center !important;
  }

  &-aligncenter {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
  }

  &-justifycenter {
    display: flex !important;
    flex-direction: column;
    justify-content: center !important;
  }

  &-bgwhite {
    background-color: #ffffff;
  }

  &-width {
    @each $width in (50, 60, 70, 80, 90, 130, 180, 300) {
      &-#{$width} {
        width: $width + px !important;
      }
    }
  }

  &-clickable:active {
    opacity: 0.5;
  }

  &-line-1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-line-2 {
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical !important;
  }
  &-line-3 {
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical !important;
  }
  &-line-4 {
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical !important;
  }
  &-line-5 {
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical !important;
  }
}

.qs-maintitle {
  font-size: 20px;
}

.qs-title {
  font-size: 18px;
}

.qs-subtitle {
  font-size: 16px;
}

.quill-editor {
  min-width: 355px;
  max-width: 355px;
}

.ql-formats {
  border: 1px solid var(--qs-border-color);
  border-radius: 4px;
  margin-right: 7px !important;
}

.ql-container {
  min-height: 300px !important;
  max-height: 300px !important;
  height: 300px !important;
  font-size: 16px !important;
  line-height: initial !important;
}

.ql-snow .ql-picker-label {
  align-content: center !important;
  display: flex !important;
}
.isEditorContentBlank::after {
  content: "请输入内容";
  color: #f56c6c;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/App.vue